import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function OpeningHook() {
  return <section className="py-16 md:py-24 px-4 bg-brand-dark" data-id="element-120">
      <div className="max-w-2xl mx-auto" data-id="element-121">
        <FadeIn data-id="element-122">
          <div className="border-l-4 border-brand-amber pl-6 md:pl-8 py-2 mb-12" data-id="element-123">
            <p className="font-serif italic text-xl md:text-2xl text-white leading-relaxed" data-id="element-124">
              "Son las 11:45 PM. El silencio en tu casa duele. Tienes el
              teléfono en la mano y, aunque juraste no hacerlo, estás revisando
              su perfil de nuevo. Sientes ese vacío físico en el pecho, una
              mezcla de náuseas y ansiedad que no te deja respirar. No es falta
              de amor propio. Es un secuestro neuroquímico. Tu cerebro está
              adicto a una persona que ya no está, y estás sufriendo un síndrome
              de abstinencia real."
            </p>
          </div>
          <div className="flex justify-center" data-id="element-125">
            <CTAButton scrollTo="precio" data-id="element-126" />
          </div>
        </FadeIn>
      </div>
    </section>;
}